<template>
    <div class="bg-white/5 backdrop-blur-lg rounded-2xl p-6 text-white border border-white/10 h-full">
        <h3 class="text-xl font-bold mb-6 flex items-center border-b border-white/5 pb-4">
            <i class="fas fa-trophy text-yellow-500 mr-2" v-if="type === 'driver'"></i>
            <i class="fas fa-cogs text-gray-400 mr-2" v-else></i>
            {{ title }}
        </h3>

        <div class="space-y-2">
            <div v-for="(item, index) in list" :key="index"
                class="flex items-center justify-between p-3 hover:bg-white/5 rounded-lg transition duration-200 group border border-transparent hover:border-white/5">
                <div class="flex items-center">
                    <div class="font-bold text-gray-500 w-8 text-lg">{{ item.position }}</div>
                    <div>
                        <div class="font-bold text-lg" v-if="type === 'driver'">
                            {{ item.Driver.givenName }} <span class="font-bold">{{ item.Driver.familyName }}</span>
                        </div>
                        <div class="font-bold text-lg" v-else>{{ item.Constructor.name }}</div>

                        <div class="text-xs text-gray-400 uppercase tracking-wider" v-if="type === 'driver'">
                            <span :style="{ backgroundColor: getTeamColor(item.Constructors[0]?.constructorId) }"
                                class="w-2 h-2 rounded-full inline-block mr-1 align-middle shadow-[0_0_5px_rgba(0,0,0,0.3)]"></span>
                            {{ item.Constructors[0].name }}
                        </div>
                        <div class="text-xs text-gray-400 uppercase tracking-wider" v-else>
                            <span :style="{ backgroundColor: getTeamColor(item.Constructor?.constructorId) }"
                                class="w-2 h-2 rounded-full inline-block mr-1 align-middle shadow-[0_0_5px_rgba(0,0,0,0.3)]"></span>
                        </div>
                    </div>
                </div>
                <div class="font-mono text-white font-bold bg-white/10 px-3 py-1 rounded-md text-right min-w-[4rem]">
                    {{ item.points }} <span class="text-[0.6rem] text-gray-400 block -mt-1 uppercase">PTS</span>
                </div>
            </div>
            <div v-if="list.length === 0" class="text-center text-gray-500 py-12 animate-pulse">
                Caricamento dati...
            </div>
        </div>
    </div>
</template>

<script>
import { getTeamColor } from '../utils/teamColors';

export default {
    name: 'StandingsCard',
    props: {
        title: {
            type: String,
            required: true
        },
        list: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: 'driver' // 'driver' or 'constructor'
        }
    },
    methods: {
        getTeamColor(id) {
            return getTeamColor(id);
        }
    }
}
</script>
